import { Box, useTheme } from '@mui/material'
import { useEntitiesFromSearch } from 'api/search'
import InlineLoading from 'components/DataGrid/InlineLoading'
import { useParams } from 'react-router-dom'
import DealInfoCard from './DealInfoCard'

const DealsDetails = () => {
  const { SK } = useParams()
  const dealId = SK?.split('DEAL_')?.[1]
  const { isItemsLoading } = useEntitiesFromSearch()
  const theme = useTheme()

  return (
    <Box
      sx={{
        height: '100%',
        overflowY: 'auto',
        p: 1,
        '&::-webkit-scrollbar': { width: '6px' },
        '&::-webkit-scrollbar-track': {
          boxShadow:
            theme.palette.mode === 'dark'
              ? 'inset 0 0 6px rgba(0,0,0,0.3)'
              : 'inset 0 0 6px rgba(255,255,255,0.3)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor:
            theme.palette.mode === 'dark'
              ? theme.palette.background.scrollbar_thumb
              : 'rgba(0,0,0,0.5)',
          borderRadius: '6px',
          '&:hover': { backgroundColor: 'text.secondary' },
        },
      }}
    >
      {isItemsLoading ? <InlineLoading /> : <DealInfoCard key={dealId} />}
    </Box>
  )
}

export default DealsDetails
